import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>404 - Página Não Encontrada</h1>
      <p>A página que você está tentando acessar não existe.</p>
    </div>
  );
};

export default NotFound;
